import React from 'react';

const LoadingBar = ({ progress = null, text = 'Carregando...' }) => {
  const isIndeterminate = progress === null;
  
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/80 backdrop-blur-sm" data-testid="loading-overlay">
      <div className="flex flex-col items-center gap-4 w-full max-w-md px-8">
        <div className="progress-container">
          <div 
            className={`progress-bar ${isIndeterminate ? 'progress-bar-indeterminate' : ''}`}
            style={!isIndeterminate ? { width: `${progress}%` } : undefined}
          />
          <div className="progress-text">{text}</div>
          <div className="particles">
            <div className="particle" />
            <div className="particle" />
            <div className="particle" />
            <div className="particle" />
            <div className="particle" />
          </div>
        </div>
      </div>

      <style>{`
        .progress-container {
          position: relative;
          width: 100%;
          height: 24px;
          background: radial-gradient(circle, #1a3a2a, #0a1a12);
          border-radius: 30px;
          overflow: hidden;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
          box-sizing: border-box;
          border: 1px solid #2d5a3f;
        }

        .progress-bar {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 40%;
          background: linear-gradient(90deg, #1a7a4c, #2d9d5f);
          border-radius: 30px;
          animation: grow 2s ease-in-out forwards;
          box-shadow: 0 0 15px #1a7a4c, 0 0 30px #2d9d5f;
        }

        .progress-bar-indeterminate {
          width: 40% !important;
          animation: slide 1.8s ease-in-out infinite !important;
        }

        .progress-bar::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(255, 255, 255, 0.15), transparent);
          opacity: 0.5;
          animation: ripple 3s infinite;
        }

        .progress-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.5px;
          color: #fff;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
          z-index: 2;
          white-space: nowrap;
        }

        .particles {
          position: absolute;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        .particle {
          position: absolute;
          width: 3px;
          height: 3px;
          background: #4ade80;
          border-radius: 50%;
          opacity: 0.5;
          animation: float 5s infinite ease-in-out;
        }

        @keyframes grow {
          0% { width: 0; }
          100% { width: 40%; }
        }

        @keyframes slide {
          0% { left: -40%; }
          100% { left: 100%; }
        }

        @keyframes ripple {
          0% { transform: translate(-50%, -50%) scale(0.5); opacity: 0.7; }
          100% { transform: translate(-50%, -50%) scale(1.5); opacity: 0; }
        }

        @keyframes float {
          0% { transform: translateY(0) translateX(0); }
          50% { transform: translateY(-15px) translateX(8px); }
          100% { transform: translateY(0) translateX(0); }
        }

        .particle:nth-child(1) { top: 10%; left: 20%; animation-delay: 0s; }
        .particle:nth-child(2) { top: 30%; left: 70%; animation-delay: 1s; }
        .particle:nth-child(3) { top: 50%; left: 50%; animation-delay: 2s; }
        .particle:nth-child(4) { top: 80%; left: 40%; animation-delay: 1.5s; }
        .particle:nth-child(5) { top: 90%; left: 60%; animation-delay: 2.5s; }
      `}</style>
    </div>
  );
};

export default LoadingBar;
